import React from "react"
import { Messages } from "./components/messages"
import { ApprovalBanner } from "app/account/approval-banner"
import { FreeOverLimitBanner } from "./components/free-over-limit-banner"
import { CancellationPendingBanner } from "./components/cancellation-pending-banner"
import { UnconfirmedUserEmailBanner } from "app/account/unconfirmed-user-email-banner"
import { UnconfirmedSendAddressBanner } from "app/account/unconfirmed-send-address-banner"
import { UnpaidBanner } from "./components/unpaid-banner"
import { TrialEndedBanner } from "./components/trial-ended-banner"
import { RequiredInfoBanner } from "./components/required-info-banner"
import { TrialUpgradeBanner } from "./components/trial-upgrade-banner"
import { SignalsLaunchOfferBanner } from "./components/signals-launch-offer-banner"

export function LayoutBanners({ layoutConfig }) {
  if (!layoutConfig?.components) return null

  const { components } = layoutConfig

  return (
    <>
      {components.messages?.visible && (
        <Messages {...components.messages.data} />
      )}

      {components.inReview?.visible && (
        <ApprovalBanner {...components.inReview.data} />
      )}

      {components.freeOverLimit?.visible && (
        <FreeOverLimitBanner {...components.freeOverLimit.data} />
      )}

      {components.cancellationPending?.visible && (
        <CancellationPendingBanner {...components.cancellationPending.data} />
      )}

      {components.unconfirmedUserEmail?.visible && (
        <UnconfirmedUserEmailBanner {...components.unconfirmedUserEmail.data} />
      )}

      {components.unconfirmedSendAddress?.visible && (
        <UnconfirmedSendAddressBanner
          {...components.unconfirmedSendAddress.data}
        />
      )}

      {components.unpaid?.visible && <UnpaidBanner />}

      {components.trialEnded?.visible && <TrialEndedBanner />}

      {components.requiredInfo?.visible && (
        <RequiredInfoBanner {...components.requiredInfo.data} />
      )}

      {components.trialUpgrade?.visible &&
        window.location.pathname !== "/upgrade" && (
          <TrialUpgradeBanner {...components.trialUpgrade.data} />
        )}

      {components.signalsLaunchOffer?.visible && (
        <SignalsLaunchOfferBanner {...components.signalsLaunchOffer.data} />
      )}
    </>
  )
}
